export const theme = {
  color: {
    black: "#000000",
    pink: "pink",
  },
};
